module.exports = __webpack_public_path__ + "img/服务理念22.png.aa65f966.png";